const {
    mapLineItemsFromSalesOrderDetailLineItemDetails,
    mapShippingFromSalesOrderDetailShipping,
    mapOrderTotalsFromSalesOrderDetail,
    mapAdrFromSalesOrderDetail,
    mapMessagesFromSalesOrder,
    mapPaymentsFromSalesOrder,
    getValueFromSalesOrderCustom
} = require('./mappings');

const fromSalesOrderResponse = (salesOrderResponse) => {
    if (salesOrderResponse == null) {
        return null;
    }

    const order = {};
    if (salesOrderResponse.SalesOrderDetail) {
        const eventCode = getValueFromSalesOrderCustom(salesOrderResponse.SalesOrderDetail.Custom, 'CODE', 'EVENT'),
            sender = getValueFromSalesOrderCustom(salesOrderResponse.SalesOrderDetail.Custom, 'SENDER'),
            shippingPayWithPoints = getValueFromSalesOrderCustom(salesOrderResponse.SalesOrderDetail.Custom, 'ZZUSE_PTS'),
            microsite = getValueFromSalesOrderCustom(salesOrderResponse.SalesOrderDetail.Custom, 'REASON', 'REASON');
        order.action = salesOrderResponse.SalesOrderDetail.OrderAction;
        order.soldToMemberId = salesOrderResponse.SalesOrderDetail.SoldToMemberID;
        order.salesOffice = salesOrderResponse.SalesOrderDetail.SalesOffice;
        order.orderId = salesOrderResponse.SalesOrderDetail.OrderID;
        order.adr = mapAdrFromSalesOrderDetail(salesOrderResponse.SalesOrderDetail);
        order.countryCode = salesOrderResponse.SalesOrderDetail.CountryCode;
        order.date = salesOrderResponse.SalesOrderDetail.Date;
        order.dateCancelled = salesOrderResponse.SalesOrderDetail.DateCancelled;
        order.dateReturned = salesOrderResponse.SalesOrderDetail.DateReturned;
        order.productDiscountCode = salesOrderResponse.SalesOrderDetail.ProductDiscountCode;
        order.shippingDiscountCode = salesOrderResponse.SalesOrderDetail.ShippingDiscountCode;
        order.commissionableInPriorMonth = salesOrderResponse.SalesOrderDetail.CommissionableInPriorMonth;
        order.commissionedInPriorMonth = salesOrderResponse.SalesOrderDetail.CommissionedInPriorMonth;
        order.reason = salesOrderResponse.SalesOrderDetail.Reason;
        order.currencyCode = salesOrderResponse.SalesOrderDetail.Currency;
        order.status = salesOrderResponse.SalesOrderDetail.Status;
        order.type = salesOrderResponse.SalesOrderDetail.Type;
        order.category = salesOrderResponse.SalesOrderDetail.Category;
        order.channel = salesOrderResponse.SalesOrderDetail.Channel;
        order.externalId = salesOrderResponse.SalesOrderDetail.ExternalID;
        order.giftReceipt = salesOrderResponse.SalesOrderDetail.GiftReciept; // typo in SalesOrderDetail model
        order.lineItems = mapLineItemsFromSalesOrderDetailLineItemDetails(
            salesOrderResponse.SalesOrderDetail);
        order.shipping = mapShippingFromSalesOrderDetailShipping(
            salesOrderResponse.SalesOrderDetail.Shipping);
        order.serialNumber = salesOrderResponse.SalesOrderDetail.SerialNumber;
        order.orderTotals = mapOrderTotalsFromSalesOrderDetail(salesOrderResponse.SalesOrderDetail.OrderTotals),
        order.pricing = salesOrderResponse.SalesOrderDetail.Pricing;
        order.payments = mapPaymentsFromSalesOrder(salesOrderResponse.SalesOrderDetail.Payment);
        // Custom fields
        if (eventCode) order.eventCode = eventCode;
        if (sender) order.sender = sender;
        if (shippingPayWithPoints) order.shippingPayWithPoints = shippingPayWithPoints;
        if (microsite) order.microsite = microsite;
    }
    order.messages = mapMessagesFromSalesOrder(salesOrderResponse.Messages);
    order.timeStamp = salesOrderResponse.TimeStamp;
    order.orderProcessingState = salesOrderResponse.orderProcessingState;
    order.redirectUrl = salesOrderResponse.redirectUrl;
    return order;
};

module.exports = fromSalesOrderResponse;
